import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z","key":"svg-0"}]]

const IconRectangleFilled = createReactComponent('filled', 'rectangle-filled', 'RectangleFilled', __iconNode);

export default IconRectangleFilled;